import { render } from "./StateRule.vue?vue&type=template&id=23a4c89b"
import script from "./StateRule.vue?vue&type=script&lang=js"
export * from "./StateRule.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__